export default __webpack_public_path__ + "static/media/avatar-2.097c9d6d.png";